import React from 'react';

interface propsTypes {
  children?: React.ReactNode;
  className?: string;
}

const H6 = (props:propsTypes) => {
  const { children  } = props;
  return <h6 {...props}>{children}</h6>;
};

export default H6;
